import { entitiesSagas } from "./entities/entities-sagas";
import { featuresSagas } from "./features/features-sagas";
import { sagaMiddleware } from "./store";
import { viewSagas } from "./views/views-sagas";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function runAppSagas() {
  sagaMiddleware.run(viewSagas);
  sagaMiddleware.run(entitiesSagas);
  sagaMiddleware.run(featuresSagas);
}
